import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
var SECTION_TYPES = {
  NAMED: 'section',
  ANONYMOUS: 'anonymous-section'
};

/**
 * Splits an array of contentItems into an array of sections
 *
 * Section can be one of two types:
 * - NAMED: An admin-created, named section that can have a description
 * - ANONYMOUS: An implicit section that has no title or description.
 * Used for contentItems that occur before the first named section
 *
 * @typedef {object} Section
 * @property {string} type
 * @property {object} data - Meta data of named sections (name and description)
 * @property {Array} contentItems - The contentItems that make up the section
 * @property {number} startOffset - The list number offset of the contentItems within the section
 *
 * @param {Array} contentItems - The contentItems to build a section structure from
 *
 * @returns {Section[]} - An array of sections
 */

function splitContentItemsIntoSections(contentItems) {
  var sections = [{
    type: SECTION_TYPES.ANONYMOUS,
    data: undefined,
    contentItems: [],
    startOffset: 1
  }];
  var contentItemCount = 0;
  contentItems.forEach(function (contentItem, i) {
    var isFirstContentItem = i === 0;
    var lastSection = sections[sections.length - 1];
    if (contentItem.type === 'section') {
      // If first contentItem is section, replace initialSection
      if (isFirstContentItem) {
        sections[0].type = SECTION_TYPES.NAMED;
        sections[0].data = contentItem;
      }

      // Otherwise add a new section
      else {
        sections.push({
          type: SECTION_TYPES.NAMED,
          data: contentItem,
          contentItems: [],
          startOffset: contentItemCount + 1
        });
      }
    } else {
      // This is an contentItem in a named section, therefore
      // we simply add it to it
      lastSection.contentItems.push(contentItem);
      contentItemCount++;
    }
  });
  return sections;
}
export { SECTION_TYPES, splitContentItemsIntoSections };